import React from "react";
import Flashcard from "./components/flashcard";
import CompletionSlide from "./components/completionslide";
import ProgressArc from "./../../components/ui_elements/progressArc";
import ReviewFlashcard from "./components/reviewflashcard";
import OverleafStore from "../../stores/overleaf-store";
import Dispatcher from "../../dispatcher";
import classnames from "classnames";
import Isvg from "../../../vendor/react-inlinesvg";
import { VstDropdown } from "vstui";
import setTitle from "../../utils/set-title";

class FlashcardViewer extends React.Component {
  constructor() {
    super();
    this.state = { loading: true, shouldShowIntroCard: null };
    this.nextCard = this.nextCard.bind(this);
    this.previousCard = this.previousCard.bind(this);
    this.restartDeck = this.restartDeck.bind(this);
    this.startOver = this.startOver.bind(this);
    this.shuffleDeck = this.shuffleDeck.bind(this);
    this.filterDeck = this.filterDeck.bind(this);
    this.focusCardHolder = this.focusCardHolder.bind(this);
    this.closeFlashCards = this.closeFlashCards.bind(this);
    this.calculateStats = this.calculateStats.bind(this);
    this.studyWeakCards = this.studyWeakCards.bind(this);
    this.cardRated = this.cardRated.bind(this);
    this.deckUpdated = this.deckUpdated.bind(this);
    this.keyboardNavigation = this.keyboardNavigation.bind(this);
    this.viewReviewSlide = this.viewReviewSlide.bind(this);
    this.shouldShowIntroCard = this.shouldShowIntroCard.bind(this);
    this.resetToIntroCard = this.resetToIntroCard.bind(this);
    this.renderXofX = this.renderXofX.bind(this);
  }

  initializeSession() {
    this.setState(
      {
        currentCardIndex: this.findCardIndexById(
          this.state.cards,
          this.props.cardId
        ),
        done: null,
        viewSummary: null
      },
      this.handleNoCardId
    );
  }

  keyboardNavigation(event) {
    if (event.keyCode === 37) {
      this.previousCard();
    } else if (event.keyCode === 39) {
      this.nextCard();
    }
  }

  componentDidMount() {
    document.title = setTitle(Fraction.Brand, "Flashcard Viewer");
    this.setState({ query: this.props.query.singleDeck });
    this.initializeDeck(true);
    Dispatcher.bind(Dispatcher.OVERLEAF_CARD_RATED, this.cardRated);
    Dispatcher.bind(Dispatcher.OVERLEAF_DECK_UPDATED, this.deckUpdated);
    document.addEventListener("keydown", this.keyboardNavigation, false);
    Fraction.Reporter.noticeInteraction("flashcards-open-deck", {
      deckId: this.props.deckId
    });
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.OVERLEAF_CARD_RATED, this.cardRated);
    Dispatcher.unbind(Dispatcher.OVERLEAF_DECK_UPDATED, this.deckUpdated);
    document.removeEventListener("keydown", this.keyboardNavigation);
  }

  originalCards(deck) {
    return OverleafStore.getCards(deck.uuid).map((card, i) => {
      card.index = i + 1;
      return card;
    });
  }

  cardRated(uuid) {
    OverleafStore.getDeck(this.props.deckId).then(deck => {
      const updatedCard = OverleafStore.getCards(deck.uuid).find(
        card => card.uuid === uuid
      );
      this.setState({
        cards: this.state.cards.map(card =>
          card.uuid === updatedCard.uuid ? updatedCard : card
        )
      });
    });
  }

  deckUpdated(deckId) {
    OverleafStore.getDeck(this.props.deckId).then(deck => {
      this.setState({ deck });
    });
  }

  shouldShowIntroCard(deck, weak, all) {
    if (weak || all) {
      this.setState({ shouldShowIntroCard: false }, this.initializeDeck());
      return true;
    }
    let proficiencies = [];
    OverleafStore.getCards(deck.uuid).filter(function (card) {
      if (card.proficiencies) {
        if (card.proficiencies.length === 0) {
          proficiencies.push(0);
        } else if (card.proficiencies[0].level === 100) {
          proficiencies.push(card.proficiencies[0].level);
        } else {
          proficiencies.push(0);
        }
      }
    });

    // TODO: This should live somewhere else
    // eslint-disable-next-line no-extend-native
    Array.prototype.unique = function () {
      return this.filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
    };
    proficiencies = proficiencies.unique().length;
    let introCard = proficiencies > 1 ? true : false;
    this.setState({ shouldShowIntroCard: introCard });
  }

  initializeDeck(firstRun) {
    this.setState(
      {
        seed: this.getRandomSeed(!this.props.cardId),
        filter: this.getStoredFilter(!this.props.cardId),
        loading: true,
        deckNotFound: undefined
      },
      () => {
        OverleafStore.getDeck(this.props.deckId)
          .then(deck => {
            if (firstRun) {
              this.shouldShowIntroCard(deck, null, null);
            }
            document.title = setTitle(
              Fraction.Brand,
              `Flashcard Viewer: ${deck.title}`
            );
            this.setState(
              {
                deck: deck,
                loading: false,
                showIntroCard: this.state.shouldShowIntroCard,
                cards: this.shuffleFilterCards(this.originalCards(deck))
              },
              this.initializeSession
            );
          })
          .catch(response => {
            this.setState({
              deckNotFound: true,
              loading: false
            });
          });
      }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.deckId !== this.props.deckId) {
      this.setState({ deck: undefined, cards: undefined }, this.initializeDeck);
    } else {
      this.setState(
        {
          currentCardIndex: this.findCardIndexById(
            this.state.cards,
            nextProps.cardId
          )
        },
        this.handleNoCardId
      );
    }
  }

  findCardIndexById(cards, cardId) {
    return Math.max(
      0,
      cards.findIndex(card => card.uuid === cardId)
    );
  }

  handleNoCardId() {
    if (
      !this.props.cardId ||
      !OverleafStore.getCards(this.state.deck.uuid).find(
        card => card.uuid === this.props.cardId
      )
    ) {
      this.updateURL(0);
    }
  }

  updateURL(cardNumber) {
    if (this.state.cards.length > 0) {
      const card = this.state.cards[cardNumber];
      Fraction.Router.setRoute(
        `/flashcards/deck/${this.props.deckId}/card/${card.uuid}`
      );
    }
  }

  nextCard() {
    if (this.state.currentCardIndex + 1 >= this.state.cards.length) {
      this.setState({ viewSummary: true });
      Fraction.Reporter.noticeInteraction("flashcards-deck-completed", {
        deckId: this.props.deckId
      });
    } else {
      const newIndex = this.state.currentCardIndex + 1;
      if (this.state.cards[newIndex]) {
        this.updateURL(newIndex);
        Fraction.Reporter.noticeInteraction("flashcards-deck-navigate", {
          cardId: this.state.cards[newIndex].uuid
        });
      }
    }
  }

  previousCard() {
    if (this.state.currentCardIndex > 0) {
      const newIndex = this.state.currentCardIndex - 1;
      if (this.state.cards[newIndex]) {
        this.updateURL(newIndex);
        Fraction.Reporter.noticeInteraction("flashcards-deck-navigate", {
          cardId: this.state.cards[newIndex].uuid
        });
      }
    }
  }

  calculateStats() {
    let statsAccumulation = { confident: 0, notConfident: 0 };
    if (this.state.cards) {
      this.state.cards.forEach(card => {
        switch (card.confidence) {
          case OverleafStore.CONFIDENCE.CONFIDENT:
            statsAccumulation.confident++;
            break;
          case OverleafStore.CONFIDENCE.NOT_CONFIDENT:
            statsAccumulation.notConfident++;
            break;
          default:
            statsAccumulation.notConfident++;
        }
      });
    }
    return statsAccumulation;
  }

  startOver() {
    this.restartDeck();
    Fraction.Reporter.noticeInteraction("flashcards-start-over", {
      deckId: this.props.deckId
    });
  }

  restartDeck() {
    this.updateURL(0);
    this.setState({ currentCardIndex: 0, viewSummary: false, done: false });
    Fraction.Reporter.noticeInteraction("flashcards-restart-deck", {
      deckId: this.props.deckId
    });
  }

  getRandomSeed(refresh) {
    let seed = parseFloat(Fraction.Helpers.getItem("overleaf-random-seed"));
    if (refresh) {
      seed = Math.random();
      Fraction.Helpers.setItem("overleaf-random-seed", seed);
    }
    return seed;
  }

  getStoredFilter(refresh) {
    let filter = Fraction.Helpers.getItem("overleaf-stored-filter");
    if (refresh || filter === "undefined") {
      Fraction.Helpers.setItem("overleaf-stored-filter", undefined);
      return undefined;
    }
    return parseInt(filter);
  }

  shuffleDeck() {
    this.setState({ seed: this.getRandomSeed(true) }, () => {
      this.refreshDeck(this.restartDeck);
    });
    Fraction.Reporter.noticeInteraction("flashcards-shuffle-deck", {
      deckId: this.props.deckId
    });
  }

  closeFlashCards() {
    Fraction.Reporter.noticeInteraction("flashcards-close-deck", {
      deckId: this.props.deckId
    });
    window.close();
  }

  filterDeck(filterType) {
    Fraction.Helpers.setItem("overleaf-stored-filter", filterType);
    this.setState({ filter: filterType, stats: {} }, () => {
      this.refreshDeck(this.restartDeck);
    });
    Fraction.Reporter.noticeInteraction("flashcards-filter-deck", {
      deckId: this.props.deckId,
      filterType: filterType
    });
  }

  studyWeakCards() {
    this.filterDeck(OverleafStore.CONFIDENCE.NOT_CONFIDENT);
  }

  renderXofX() {
    if (!this.state.loading && !this.state.deckNotFound) {
      return (
        <div className="xofx">
          {this.state.currentCardIndex + 1}/{this.state.cards.length}
        </div>
      );
    }
  }

  focusCardHolder() {
    $(this.cardHolder).scrollLeft(0);
  }

  renderFilterButton(hidden) {
    const currentFilter = this.state.filter;
    let currentCard = this.state.currentCardIndex;
    let totalCards = this.state.cards && this.state.cards.length;
    if (
      !this.state.done &&
      (currentCard < totalCards || currentCard + 1 === totalCards)
    ) {
      return false;
    }
    return (
      <div style={hidden}>
        <VstDropdown
          className="confidence-filter"
          vertical={"top"}
          horizontal={"left"}
          target={
            <button
              className="noButton"
              title={i18n.t("flashcards.filter-deck")}
            >
              <span className="hintText">
                {i18n.t("flashcards.filter-deck")}
              </span>
              <Isvg src="img/filters.svg" />
            </button>
          }
        >
          <VstDropdown.Item role="subheader">
            {i18n.t("flashcards.filter")}
          </VstDropdown.Item>
          <VstDropdown.Item
            selected={currentFilter === undefined}
            onClick={() => this.filterDeck(undefined)}
          >
            <div className="confidence-item all">
              <span>{i18n.t("flashcards.all")}</span>
            </div>
            {currentFilter === undefined && (
              <Isvg src="img/checkmark.svg" className="selected" />
            )}
          </VstDropdown.Item>
          <VstDropdown.Item
            selected={currentFilter === OverleafStore.CONFIDENCE.NOT_CONFIDENT}
            onClick={() =>
              this.filterDeck(OverleafStore.CONFIDENCE.NOT_CONFIDENT)
            }
          >
            <div className="confidence-item wrong">
              <span>{i18n.t("reader.flashcards.dont-know-it")}</span>
            </div>
            {currentFilter === OverleafStore.CONFIDENCE.NOT_CONFIDENT && (
              <Isvg src="img/checkmark.svg" className="selected" />
            )}
          </VstDropdown.Item>
          <VstDropdown.Item
            selected={currentFilter === OverleafStore.CONFIDENCE.CONFIDENT}
            onClick={() => this.filterDeck(OverleafStore.CONFIDENCE.CONFIDENT)}
          >
            <div className="confidence-item correct">
              <span>{i18n.t("reader.flashcards.know-it")}</span>
            </div>
            {currentFilter === OverleafStore.CONFIDENCE.CONFIDENT && (
              <Isvg src="img/checkmark.svg" className="selected" width={12} />
            )}
          </VstDropdown.Item>
        </VstDropdown>
      </div>
    );
  }

  renderLeftHeaderButtons() {
    if (!this.state.loading && !this.state.deckNotFound) {
      const hidden =
        this.state.done ||
        this.state.shouldShowIntroCard ||
        this.state.showIntroCard
          ? { display: "none" }
          : null;
      const filterButton = this.renderFilterButton(hidden);
      return (
        <div id="left-buttons">
          <button
            onClick={this.closeFlashCards}
            className="noButton"
            title={i18n.t("flashcards.close-deck")}
          >
            <span className="hintText">{i18n.t("flashcards.close-deck")}</span>
            <Isvg src="img/close_x.svg" />
          </button>
          <button
            style={hidden}
            id="restart"
            onClick={this.restartDeck}
            className="noButton"
            title={i18n.t("flashcards.restart-deck")}
          >
            <span className="hintText">
              {i18n.t("flashcards.restart-deck")}
            </span>
            <Isvg src="img/refresh.svg" />
          </button>
          <button
            id="shuffle"
            style={hidden}
            onClick={this.shuffleDeck}
            className="noButton"
            title={i18n.t("flashcards.shuffle-deck")}
          >
            <span className="hintText">
              {i18n.t("flashcards.shuffle-deck")}
            </span>
            <Isvg src="img/shuffle.svg" />
          </button>
          {filterButton}
        </div>
      );
    }
  }

  renderHeader(deck) {
    let currentProgress = Math.round(
      (100 / (this.state.cards && this.state.cards.length)) *
        (this.state.currentCardIndex + 1)
    );
    let numerator = this.state.cards && this.state.currentCardIndex + 1;
    let denominator = this.state.cards && this.state.cards.length;
    let hidden =
      this.state.done ||
      this.state.shouldShowIntroCard ||
      this.state.showIntroCard ||
      this.state.loading;
    return (
      <div id="header" className={`${this.state.done ? "done" : ""}`}>
        {this.renderLeftHeaderButtons()}
        {!this.state.done && <h1 id="deck-title">{deck && deck.title}</h1>}
        <div>
          {!hidden && (
            <ProgressArc
              denominator={denominator}
              numerator={numerator}
              viewSummary={this.state.viewSummary}
              reviewComplete={false}
              showProgress={currentProgress}
            />
          )}
        </div>
      </div>
    );
  }

  shuffleFilterCards(cards) {
    const shuffle = (a, b) => {
      if (this.state.seed) {
        return 899809363 % (a.index + this.state.seed) >
          899809363 % (b.index + this.state.seed)
          ? 1
          : -1;
      } else {
        return -1;
      }
    };
    let filter = this.state.filter;
    const filterCards = item => {
      if (filter === -1) {
        return !item.confidence || item.confidence === filter;
      }
      if (filter !== undefined) {
        return (item.confidence || OverleafStore.CONFIDENCE.NEUTRAL) === filter;
      }
      return true;
    };
    return cards.sort(shuffle).filter(filterCards);
  }

  refreshDeck(callback) {
    this.setState(
      {
        cards: this.shuffleFilterCards(this.originalCards(this.state.deck))
      },
      callback
    );
  }

  viewReviewSlide() {
    this.setState({ done: true, viewSummary: false });
  }

  resetToIntroCard() {
    this.setState({ done: false, viewSummary: false, showIntroCard: true });
  }

  shouldPeekClass() {
    if (Fraction.Helpers.isAndroid() || Fraction.Helpers.isiOS()) {
      return "peek";
    }
  }

  renderMainWindow(deck, index) {
    if (this.state.done) {
      return (
        <CompletionSlide
          stats={this.calculateStats()}
          closeFlashCards={this.closeFlashCards}
          filterDeck={this.studyWeakCards}
        />
      );
    } else if (this.state.viewSummary) {
      return (
        <ReviewFlashcard
          repeat={this.startOver}
          viewReviewSlide={this.viewReviewSlide}
          focusCardHolder={this.focusCardHolder}
          restartDeck={this.resetToIntroCard}
          shuffleDeck={this.shuffleDeck}
        />
      );
    } else if (this.state.loading) {
      return (
        <div id="main-window">
          <div id="flashcard-controls" className={this.shouldPeekClass()}>
            <div id="card-holder">
              <Flashcard loading={this.state.loading} inView={true} />
            </div>
          </div>
        </div>
      );
    } else if (this.state.deckNotFound) {
      return (
        <div id="main-window">
          <div id="not-found">
            {Fraction.Brand.Graphics.watkins && (
              <img src="/img/prop_laptop_dust.svg" />
            )}
            <h2>
              {i18n.t("flashcards.uh-oh")} {i18n.t("flashcards.nothing-here")}
            </h2>
            <span className="description">
              {toHTML(i18n.t("flashcards.go-to-library", { url: "/#/" }))}
            </span>
          </div>
        </div>
      );
    } else if (this.state.cards.length === 0) {
      return (
        <div id="main-window">
          <div id="not-found">
            {Fraction.Brand.Graphics.watkins && (
              <img src="/img/watkins_search.svg" />
            )}
            <h2>{i18n.t("flashcards.nothing-here")}</h2>
            <span className="description">
              {i18n.t("flashcards.try-changing-filter")}
            </span>
          </div>
        </div>
      );
    } else if (this.state.showIntroCard) {
      return (
        <div id="main-window">
          <div id="flashcard-controls" className={this.shouldPeekClass()}>
            <div id="card-holder">
              <Flashcard
                hideIntroCard={this.shouldShowIntroCard}
                allCards={OverleafStore.getCards(this.state.deck.uuid).length}
                stats={this.calculateStats()}
                startOver={this.filterDeck}
                studyWeak={this.studyWeakCards}
                Loading={false}
                introCard={true}
                inView={true}
                deckId={this.props.deckId}
              />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="main-window">
          <div id="flashcard-controls" className={this.shouldPeekClass()}>
            <button
              id="previous-flashcard"
              className={classnames("nav-button", { disabled: index === 0 })}
              onClick={this.previousCard}
              disabled={index === 0 ? true : false}
            >
              <Isvg src="/img/chevron_left_large.svg" />
              <span className="hintText">
                {i18n.t("flashcards.previous-card")}
              </span>
            </button>
            <div
              id="card-holder"
              ref={ch => {
                this.cardHolder = ch;
              }}
            >
              {this.state.cards.map((card, i) => {
                return (
                  <Flashcard
                    {...card}
                    focusCardHolder={this.focusCardHolder}
                    key={`flashcard-${card.uuid}`}
                    inView={index === i}
                    progressHint={i18n.t("flashcards.x-of-y", {
                      x: index + 1,
                      y: this.state.cards.length
                    })}
                    isLeft={i < index}
                    isRight={i > index}
                    immediateLeft={index === i + 1}
                    immediateRight={index === i - 1}
                    canSwipeRight={i > 0}
                    nextCard={this.nextCard}
                    previousCard={this.previousCard}
                  />
                );
              })}
            </div>
            <button
              id="next-flashcard"
              className="nav-button"
              onClick={this.nextCard}
            >
              <Isvg src="/img/chevron_left_large.svg" />
              <span className="hintText">
                {index === this.state.cards.length - 1
                  ? i18n.t("flashcards.finish-deck")
                  : i18n.t("flashcards.next-card")}
              </span>
            </button>
          </div>
          {this.renderXofX()}
        </div>
      );
    }
  }

  render() {
    const deck = this.state.deck;
    const index = this.state.currentCardIndex;

    return (
      <div id="overleaf">
        {this.renderHeader(deck)}
        {this.renderMainWindow(deck, index)}
      </div>
    );
  }
}

export default FlashcardViewer;
